module.exports = __webpack_public_path__ + "static/media/SashaMorgan2026CVResume.424f1f7b.pdf";